import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactModal from 'react-modal';
import Ink from 'react-ink';

import * as ModalsActions from '../ModalsActions';
import './Style';

class DisclaimerModalContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            defaultDisclaimer: 'Any floor plans provided are not intended to be,'
            + ' nor should they be relied on as, official architectural drawings or '
            + ' similar renderings of a floor plan by a licensed, professional architect,'
            + ' engineer or other similar professional. This site is not responsible or'
            + ' liable for any acts or omissions created or the result of inaccurate'
            + ' measurements or placement of details within a floor plan rendering. It is'
            + ' recommended that persons interested in the exact floor plan of the property'
            + ' in question consult a licensed architect, engineer or check with the local'
            + ' government offices of the city in which the property is located for the'
            + ' official blue prints or architectural drawings of the property.'
            + '<br/>NY State Housing and Anti-Discrimination'
            + ' <a href="https://www.dos.ny.gov/licensing/docs/FairHousingNotice_new.pdf" target="_blank">Notice</a> and '
            + '<a href="https://www.dos.ny.gov/licensing/docs/2156.pdf" target="_blank">Disclosure</a>'
        }

      this.closeModal = this.closeModal.bind(this);
    }

    closeModal() {
        this.props.modalsActions.changeModalVisibility('modalDisclaimer', false);
    }

    render() {
        const { modalDisclaimerIsOpen, disclaimer } = this.props;

        const disclaimerText = disclaimer ? disclaimer : this.state.defaultDisclaimer;

        return (
            <div className="disclaimer-modal-container">
                <ReactModal
                    isOpen={modalDisclaimerIsOpen}
                    style={
                        {
                            overlay: {
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                zIndex: '2'
                            },
                            content: {
                                backgroundColor: '#303131',
                                border: '1px solid #000',
                                borderRadius: 0
                            }
                        }
                    }
                    ariaHideApp={false}
                    shouldCloseOnOverlayClick={true}
                    onRequestClose={() => this.closeModal('modalDisclaimer')}
                    closeTimeoutMS={500}
                    role="dialog"
                    className='disclaimer-modal'>
                        <div className="modal-header">
                            <h1>
                                Disclaimer
                            </h1>
                            <div className="modal-close">
                                <button className="btn btn-transparent" onClick={() => this.closeModal('modalDisclaimer')}>
                                    &times;
                                    <Ink />
                                </button>
                            </div>
                        </div>
                        <div className="modal-body">
                            <p className="disclaimer-message" dangerouslySetInnerHTML={{__html:disclaimerText}}></p>
                        </div>
                    </ReactModal>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    modalDisclaimerIsOpen: state.modals.modalDisclaimerIsOpen,
    disclaimer: state.property.disclaimer.text
})

const mapDispatchToProps = (dispatch) => ({
    modalsActions: bindActionCreators(ModalsActions, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(DisclaimerModalContainer)
